var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.2996C1 11.4509 1.31607 10.637 1.87868 10.0369C2.44129 9.43675 3.20435 9.09961 4 9.09961H10C10.7956 9.09961 11.5587 9.43675 12.1213 10.0369C12.6839 10.637 13 11.4509 13 12.2996C13 12.7239 12.842 13.1309 12.5607 13.4309C12.2794 13.731 11.8978 13.8996 11.5 13.8996H2.5C2.10218 13.8996 1.72064 13.731 1.43934 13.4309C1.15804 13.1309 1 12.7239 1 12.2996Z",
    stroke: "#7D7D7C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.89955C8.24264 5.89955 9.25 4.82505 9.25 3.49958C9.25 2.17411 8.24264 1.09961 7 1.09961C5.75736 1.09961 4.75 2.17411 4.75 3.49958C4.75 4.82505 5.75736 5.89955 7 5.89955Z",
    stroke: "#7D7D7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/nameIcon.70dc200b13512f00000dbd7e2673dac0.svg";
export { ForwardRef as ReactComponent };